import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DoNotSellLink } from '@/components/DoNotSellLink';

// Footer organism — site-wide footer with privacy + terms + CCPA link +
// 风隐 OS provenance attribution.
// P5 privacy fix #5: DoNotSellLink mounted here.
// iter_3: tagline replaced "Built by an indie hacker" with windborne OS
// provenance — this product is generated by spec → Gemma → sub-agent → QC →
// deploy pipeline, not hand-coded.
export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      className="border-t border-hairline mt-12 px-8 py-8 text-sm text-ink-3"
      data-testid="site-footer"
    >
      <div className="max-w-page mx-auto flex flex-wrap items-center gap-x-6 gap-y-3 justify-between">
        <div className="flex flex-col gap-0.5">
          <span data-testid="footer-tagline">{t('footer.tagline')}</span>
          <span className="text-[10px] tracking-meta uppercase text-ink-3/70 font-mono">
            {t('footer.taglineSub')}
          </span>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 items-center">
          <Link to="/legal/privacy" className="hover:text-ink underline-offset-2 hover:underline">
            {t('footer.privacy')}
          </Link>
          <Link to="/legal/terms" className="hover:text-ink underline-offset-2 hover:underline">
            {t('footer.terms')}
          </Link>
          <Link to="/how-it-works" className="hover:text-ink underline-offset-2 hover:underline">
            {t('nav.howItWorks')}
          </Link>
          <DoNotSellLink />
        </div>
      </div>
    </footer>
  );
}
